import split from 'lodash/split';

export default (search='', word='') => {
  const regex = split(search, '').join('.*').toLowerCase();
  return new RegExp(`.*${regex}.*`).test(word.toLowerCase());
};
